module.exports = __webpack_public_path__ + "img/aj-resolutelab.8010d51a.jpg";